<template>
    <div v-if="loading" class="text-center m-2">
        <div class="spinner-border text-primary" role="status">
        </div>
    </div>
    <div v-else>
        <div class="row">
            <div class="col-sm-6" v-for="(item, index) in entries">
                <div class="meistgelesen_item" :class="{double_border: index < 2}">
                    <a :href="item.url">
                        <div class="count">{{index + 1}}</div>
                        <div class="label">
                            <h3>{{item.nodeName}}</h3>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import Axios from 'axios';

    export default {

        props: {
            language: {
                type: String,
                required: true
            },
            amount: {
                type: String,
                required: true
            },
            daysBack: {
                type: String,
                required: true
            },
            categorie: {
                type: String,
                required: true
            }

        },
        data() {
            return {
                entries: {},
                loading: true,
            };
        },

        mounted() {
            this.countCounter();
        },
        methods: {
          getImage(id){
            
          },
            countCounter() {
                this.loading = true;
                Axios.get(`/umbraco/mdmostread/counter/getList?language=${this.language}&amount=${this.amount}&daysBack=${this.daysBack}&categorie=${this.categorie}`).then(response => {
                    this.entries = response.data;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });

            }
        }
    }

</script>